module.exports = __webpack_public_path__ + "static/media/Initials.53f73fb5.png";